import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 30, className = "", once = true }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-70px" }}
      transition={{ duration: 0.85, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
};

export const KineticText = ({
  lines = [],
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.11,
  animateOnLoad = true,
}) => {
  const reduce = useReducedMotion();
  const anim = { y: 0, opacity: 1 };
  const init = reduce ? false : { y: "115%", opacity: 0 };
  const commonProps = animateOnLoad
    ? { animate: anim }
    : { whileInView: anim, viewport: { once: true, margin: "-60px" } };

  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.18em] -mb-[0.1em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={init}
            {...commonProps}
            transition={{ duration: 0.95, delay: delay + i * stagger, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
